export default __webpack_public_path__ + "static/media/disable-banner.bd379edc.jpg";